import ol from 'openlayers';

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import SelectWrapped from './MultiselectComponent';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';

import AddressPicker from './AddressPickerComponent';

import 'font-awesome/css/font-awesome.min.css';
import './featureEditor.css';
import './lib/common';
import { postData } from './lib/common';

const panelStyles = {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto'
}


class FeatureCreatorComponent extends Component {
    state = {}

    async componentWillMount() {
        let resp = await fetch('/api/metadata?cities&fields_schema', {credentials: 'include'})
        let data = await resp.json()
        this.setState({
            CITIES: data['cities'],
            FIELDS_SCHEMA: data['fields_schema'],
        })
    }

    saveObject () {
        const {onAddModeChange, onSelectClick } = this.props
        
        const newObject = {
            address: this.state.address,
            name: this.state.name,
            geodata: {
                coords: ol.proj.transform(this.selectedFeature.getGeometry().getCoordinates(), 'EPSG:3857', 'EPSG:4326')
            },
            building_type: this.state.building_type,
            city: this.state.city,
        }

        postData(
            '/api/features',
            newObject
        ).then(
            id => {
                Object.keys(this.state.FIELDS_SCHEMA.default.fields).map(field => {
                    this.selectedFeature.set(field, null)
                })
                this.selectedFeature.setId(id)
                this.selectedFeature.set("id", id)
                this.selectedFeature.set("name", newObject.name)
                this.selectedFeature.set("address", newObject.address)
                this.selectedFeature.set("building_type", newObject.building_type)
                this.selectedFeature.set("city", newObject.city)
                console.log('successfully added ' + id);
                onSelectClick(this.selectedFeature.getId())
                this.finishCreation();
            }
        ).catch(
            error => console.log(error)
        ).finally(
            () => {
                onAddModeChange(false, false)
            }
        )
    }

    setAddress(address, point) {
        const { saveFeatureGeom } = this.props
        this.setState({address: address})
        if (point) {
            saveFeatureGeom('tmp', 'place')
        } else {
            saveFeatureGeom('tmp', 'cluster')
        }
    }

    componentWillUpdate() {
        const {authorizedUser} = this.props
        if (authorizedUser && authorizedUser.city && !this.state.city) {
            this.setState({
                city: authorizedUser.city,
            })
        }
    }

    componentDidUpdate() {
        const {savePlaceOrCluster, saveFeatureGeom} = this.props

        if (savePlaceOrCluster !== null && typeof(savePlaceOrCluster) === 'object' && savePlaceOrCluster[0] === 'done') {
            this.selectedFeature = savePlaceOrCluster[1]
            
            saveFeatureGeom(null, null)
        }

        if (this.createdNew && this.selectedFeature && this.state.coords) {
            this.selectedFeature.getGeometry().setCoordinates(ol.proj.transform(this.state.coords, 'EPSG:4326', 'EPSG:3857'))
            this.createdNew = false
        }
    }

    finishCreation() {
        const { onAddModeChange, onEditModeChange } = this.props
        this.setState({address: null, name: '', building_type: null, city: null})
        onAddModeChange(false, false);
        onEditModeChange(false);
    }

    validate() {
        if (
            !this.state.address
            || !this.state.name
            || !this.state.building_type
            || !this.state.city
        ) {
            this.setState({validationError: true})
            return false
        } else {
            this.setState({validationError: false})
            return true
        }
    }

    render () {
        const { onAddModeChange, classes } = this.props;
        if (!this.state.FIELDS_SCHEMA){
            return null;
        }
        const city_map = this.state.CITIES.map(x=>{let a = {}; a[x] = x; return a}).reduce((a, c) => {return {...a, ...c}}, {})

        return (
            <div style={panelStyles}>
                <Typography style={{
                    paddingLeft: '24px',
                    paddingRight: '24px'
                }}>Щелкните на карту, или введите адрес в поле ниже, чтобы создать объект.</Typography>
                <List component="nav" style={{height: '100%'}}>
                    <ListItem style={{paddingTop: '0.25em', paddingBottom: '0.5em'}}>
                        <ListItemText
                            primary={<TextField
                                value={this.state.name}
                                onChange={(e) => {this.setState({name: e.target.value})}}
                            />}
                            secondary={
                                'Название'
                            }
                            inset={false}
                        />
                    </ListItem>
                    <ListItem style={{paddingTop: '0.25em', paddingBottom: '0.5em'}}>
                        <ListItemText
                            primary={
                                <Input
                                  fullWidth
                                  inputComponent={SelectWrapped}
                                  value={this.state.city}
                                  onChange={(v) => {this.setState({city: v})}}
                                  placeholder="Начните набирать"
                                  name="react-select-chip-section"
                                  inputProps={{
                                    classes,
                                    multi: false,
                                    instanceId: 'react-select-chip-section',
                                    id: 'react-select-chip-section',
                                    simpleValue: true,
                                    options: Object.keys(
                                        city_map
                                    ).map(
                                        t => ({
                                          value: t,
                                          label: city_map[t],
                                        })
                                    ),
                                  }}
                                />
                            }
                            secondary={
                                'Городской округ'
                            }
                            inset={false}
                        />
                    </ListItem>
                    <ListItem style={{paddingTop: '0.25em', paddingBottom: '0.5em'}}>
                        <ListItemText
                            primary={
                                <Input
                                  fullWidth
                                  inputComponent={SelectWrapped}
                                  value={this.state.building_type}
                                  onChange={(v) => {this.setState({building_type: v})}}
                                  placeholder="Начните набирать"
                                  name="react-select-chip-section"
                                  inputProps={{
                                    classes,
                                    multi: false,
                                    instanceId: 'react-select-chip-section',
                                    id: 'react-select-chip-section',
                                    simpleValue: true,
                                    options: Object.keys(
                                        this.state.FIELDS_SCHEMA.default.fields.building_type.options
                                    ).map(
                                        t => ({
                                          value: t,
                                          label: this.state.FIELDS_SCHEMA.default.fields.building_type.options[t],
                                        })
                                    ),
                                  }}
                                />
                            }
                            secondary={
                                'Тип по деятельности'
                            }
                            inset={false}
                        />
                    </ListItem>
                    <ListItem style={{paddingTop: '0.25em', paddingBottom: '0.5em'}}>
                        <ListItemText
                            primary={<AddressPicker
                                onChange={(value) => {
                                    const {address, point} = value;
                                    this.setAddress(address, null)
                                }}
                                onSelect={(value) => {
                                    if (value && value.address && value.point) {
                                        //TODO: set place on map and center to it
                                        if (!this.selectedFeature) {
                                            this.createdNew = true

                                            onAddModeChange(['new', ol.proj.transform(value.point, 'EPSG:4326', 'EPSG:3857')])
                                            this.setAddress(value.address, value.point)
                                        } else {
                                            this.selectedFeature.getGeometry().setCoordinates(ol.proj.transform(value.point, 'EPSG:4326', 'EPSG:3857'))
                                            this.setAddress(value.address, value.point)
                                        }
                                    } else if (value && value.address && !value.point) {
                                        this.setAddress(value.address, null);
                                    }
                                }}
                            />}
                            secondary={
                                'Адрес'
                            }
                            inset={false}
                        />
                    </ListItem>
                 </List>
                 <Button 
                    color='primary'
                    onClick={() => {
                        const isValid = this.validate();
                        if (isValid) {
                            this.saveObject();
                        }
                    }}>
                        Сохранить
                </Button>
                 <Button onClick={() => this.finishCreation()}>Отмена</Button>

                 <Dialog style={{zIndex: '4000'}}
                  open={this.state.validationError}
                  onClose={() => {this.setState({validationError: false})}}
                  aria-labelledby="form-dialog-title"
                >
                  <DialogTitle id="form-dialog-title">Необходимо заполнить все поля</DialogTitle>

                  </Dialog>
            </div>
        )
    }
}

export default withStyles()(FeatureCreatorComponent)



// WEBPACK FOOTER //
// ./src/FeatureCreatorComponent.js